<ng-content select="label"></ng-content>
<div class="form-group-content">
  <ng-content></ng-content>
</div>
<div class="error-box">
  <span *ngIf="control?.errors && (control?.touched || ngForm?.submitted)" class="contextual-error"><mat-icon inline>arrow_drop_up</mat-icon>{{getErrorLabel()}}</span>
</div>
